import { __assign } from 'tslib';

function copyState(state) {
    return state
        ? __assign(__assign({}, state), { coordinates: state.coordinates && __assign({}, state.coordinates), imageSize: state.imageSize && __assign({}, state.imageSize), boundary: state.boundary && __assign({}, state.boundary), visibleArea: state.visibleArea && __assign({}, state.visibleArea), transforms: __assign(__assign({}, state.transforms), { flip: __assign({}, state.transforms.flip) }) }) : null;
}

export { copyState };
